import {UserCreate, UserEdit, UserList} from '@/admin/resources/users/Users';

export default {
  list: UserList,
  edit: UserEdit,
  create: UserCreate,
};
